export enum ConsentGroup {
    Necessary = 'C0001',
    Performance = 'C0002',
    Functional = 'C0003',
    Targeting = 'C0004',
    Media = 'C0005',
}

export class ConsentService {
    private groups: ConsentGroup[];

    private getFromCookie() {
        const match = document.cookie.match('(^| )OptanonConsent=([^;]+)');
        if (match) {
            const groups = new URLSearchParams(decodeURIComponent(match[2])).get('groups');
            if (groups) {
                return groups.split(',').reduce((acc, curr) => {
                    const group = curr.split(':');
                    if (group[1] === '1') {
                        return `${acc},${group[0]}`;
                    }
                    return acc;
                }, '');
            }
        }
    }

    public constructor() {
        const groupString = window.OnetrustActiveGroups || this.getFromCookie();
        this.groups = (groupString?.split(',').filter((x) => x !== '') as ConsentGroup[]) || [];
    }

    public hasConsent(groups: ConsentGroup[]) {
        return groups.every((g) => this.groups.includes(g));
    }
}
